var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9591 7.8729C12.8433 6.58955 12.4415 4.8784 11.2162 3.70668C9.72211 2.27809 7.38876 2.01953 6.05037 2.00013C5.43935 1.99127 4.96755 2.4421 4.97661 3.02616C4.99646 4.3055 5.26617 6.53597 6.76021 7.96456C7.94999 9.10221 9.67204 9.49787 11 9.62164V16.3405C9.48559 16.4512 7.98558 16.8138 6.56548 17.4283C5.00702 18.1027 4 19.6255 4 21.3079C4 21.6902 4.30985 22 4.69206 22H19.3079C19.6902 22 20 21.6902 20 21.3079C20 19.6255 18.993 18.1027 17.4345 17.4283C16.0144 16.8138 14.5144 16.4512 13 16.3405V16.054C13.0663 16.0626 13.1346 16.0666 13.2046 16.0657C14.7059 16.0457 17.3233 15.779 18.9992 14.3055C20.675 12.8321 20.9776 10.5315 20.9999 9.21201C21.01 8.6096 20.4808 8.14461 19.7954 8.15374C18.2941 8.17375 15.6767 8.44044 14.0008 9.91391C13.5901 10.275 13.2618 10.6859 13 11.1197V8.15361C13 8.0561 12.9857 7.96189 12.9591 7.8729Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.d14e558d5d146ed83bc8d8ab3253850a.svg";
export { ForwardRef as ReactComponent };